<template>
  <md-tab id="tab-industry" md-label="Industry" md-icon="business">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 order-2">
        <div>
          <div
            v-for="item in salesArray"
            :key="item"
            :id="item"
            :ref="item"
            :class="`len2-${getSalesName(item)} available unclicked`"
            @click="saveSale($event)"
          >{{ getSalesName(item) }}</div>
        </div>
      </div>
    </div>
  </md-tab>
</template>

<script>
import axios from 'axios';

export default {
  name: 'sales-tab',
  props: ['dataAccess'],

  data() {
    return {
      apiIndustries: undefined,
      industriesLen2: [],
      loaded: false,
      paddingMultiplier: 0,
      previousBznaics: '',
      parentBznaics: '',
      searchPaddingMultiplier: 0,
      searchParentBznaics: '',
      searchPreviousBznaics: '',
      salesArray: [],
    };
  },
  mounted() {
    if (this.dataAccess)
      Object.keys(this.dataAccess.allowedSalesClasses).forEach((item) => {
        if (this.dataAccess.allowedSalesClasses[item])
          this.salesArray.push(item);
      });
  },
  methods: {
    getSalesName: function (index) {
      return this.dataAccess.salesClassNames[index];
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    getName: function (name) {
      return name.split('[')[0];
    },

    saveSale: function (event) {
      this.$store.commit('MULT_SET_CURRENT_SALES_CLASS', `[${event.target.id}] ${event.target.innerText}`);

      if (this.currentIndustry && this.currentSalesClass && this.multCount>2)
        this.searchResults();
    },
    searchResults: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search/multiples',
          {},
          {
            params: {
              /**
               * Required parameters:
               */
              session_id: currentSession,
              bznaics: this.getData(this.currentIndustry),
              sales_class: this.getData(this.currentSalesClass)
            },
          }
        )
        .then((res) => {
          this.$store.commit('MULT_SET_SEARCHES_RESULT', res.data.search_results);
        });
    }
  },

  computed: {
    currentIndustry() {
      return this.$store.getters.multCurrentIndustry;
    },
    currentSalesClass() {
      return this.$store.getters.multCurrentSalesClass;
    },
    multCount() {
      return this.$store.getters.multCount;
    },
  },

  watch: {

    currentIndustry(newValue, oldValue) {
      this.salesArray = [];
      Object.keys(this.dataAccess.allowedSalesClasses).forEach((item) => {
        if (this.dataAccess.allowedSalesClasses[item])
          this.salesArray.push(item);
      });

      let industryId = this.getData(newValue)
      let exceptArray = this.dataAccess.removedSalesClasses[industryId];

      if (exceptArray) {
        for (var i = 0; i < this.salesArray.length; i++)
          for (var j = 0; j < exceptArray.length; j++)
            if (this.salesArray[i] === exceptArray[j])
              this.salesArray.splice(i, 1);
      }

    },    
    dataAccess(newValue, oldValue) {
      if (newValue)
        Object.keys(this.dataAccess.allowedSalesClasses).forEach((item) => {
          if (this.dataAccess.allowedSalesClasses[item])
            this.salesArray.push(item);
        });
    },
  },
};
</script>
<style lang="scss">
.unavailable {
  pointer-events: none;
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.9375rem;
  margin: 16px;
}
.available {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  margin: 16px;
  transition: 0.5s;
}
.search-indent {
  padding-left: 32px;
}
.available:hover {
  color: #1a7bfa;
  transition: 0.5s;
}
</style>
